import {
	Component,
	ElementRef, EventEmitter,
	Input,
	OnChanges,
	OnInit, Output,
	SimpleChanges,
	ViewChild,
	ViewEncapsulation,
        inject,
} from '@angular/core';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import {Router} from "@angular/router";
import { GenericConfig, EntityConfig } from '@signature-it/ngx-generic/config';
import { CarouselService, ShareDataService, SeoService_Generic } from '@signature-it/ngx-generic/services';
import { GalleryItemDTO, GalleryItemType, GalleryConfigDTO } from '@signature-it/ngx-generic/models';
import { GalleryLayout } from '@signature-it/ngx-generic/enums';

declare let _ : any;
declare var $:any;

@Component({
    selector: 'gallery',
    templateUrl: './gallery.component.html',
    styleUrls: ['./gallery.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class GalleryComponentGeneric implements OnInit, OnChanges {
     @Input() key: string = 'default';
     @Input() api: string;
     @Input() layout: string;
     @Input() hideIndicator: boolean;
	 @Input() orderDirection: string = 'ASC';
     @Input() showOriginalSize: boolean;
	 @Input() fieldCollectionVar: string;
	 @Input() hideTitle: boolean;
	 @Input() hideDescription: boolean;
	 @Input() subTitle: string;
	 @Input() entityVar: string;
	 @Input() entityTypeVar: string;
	 @Input() mediaAssetQuery: string;
	 @Input() carouselItems: number = 1;
	 @Input() carouselMobileItems: number = 1;
	 @Input() carouselItemsWidth: string = 'auto';
	 @Input() showCarouselButtons: boolean;
	 @Input() openPopupOnClick: boolean = true;
	 @Input() openPopupOnFlatClick: boolean = false;
	 @Input() autoPlay: boolean = true;
	 @Input() popular: string;
	 @Input() headingLevel: number;
	 @Input() dependSelector: any = '';
	 @Input() showButtonAutoPlay: boolean;
	 @Input() noPicSize: string;
	 @Input() collectionDataId: string = '';

	galleryItems: GalleryItemDTO[];
	 GalleryItemType = GalleryItemType;
	 GalleryLayout = GalleryLayout;
	 carouselArray;
     modalReference: any;
     indexStart = 0;
	 activeIndex = 1;
     index = 0;
	 Math;
	 libraryIndex = 0;
	 galleryId: string;
	 responsive: object;
	 gridInfo: object = {};
     entityConfig;
	 systemName = GenericConfig.systemName;
	intervalId;
	filterQuery: any = [];
	showImage: any;
	CDNPrefix = GenericConfig.CDNPrefix || '';
	noImagePic;
	carouselPlayInterval;
	showIndicatorByWidth = false;
	protected seoSvc: SeoService_Generic;

    @ViewChild('altCarouselContainer') altCarouselContainer: ElementRef;

     constructor(protected carouselService: CarouselService,
				 protected modalService: NgbModal,
                 protected router: Router,
                 public sharedSvc: ShareDataService,) {
		 this.Math = Math;
                 this.seoSvc = inject(SeoService_Generic);
     }

	async ngOnInit() {
		this.sharedSvc.hideDependElements(this.dependSelector);
		await this.init();
	}

	calculateToShowIndicator() {
		if (this.galleryItems.length && $('.carousel-indicators li')){
			if (this.galleryItems.length * $('.carousel-indicators li').width() > $('.carousel-indicators').width()){
				this.showIndicatorByWidth = true;
			}
		}
		return this.showIndicatorByWidth;
	}

	async init() {
		if(this.api) {
			this.setConfig();
			this.setParams();
			this.noImagePic = this.noPicSize ? GenericConfig.noImagePic.replace(/{size}/, this.noPicSize) : null;
			let galleryItems = await this.carouselService.getGalleryFromApi(this.api).toPromise();
			let files = galleryItems.map(item => `${location.hostname}${item.src}`);
			this.seoSvc.updatePageData('media', files);
			if(galleryItems && galleryItems.length) {
				this.galleryItems = _.filter( galleryItems, (item) => item.src && this.filterQuery.every(f => {
					return item[f[0]]?.toString() == f[1]})
				);
				if (this.galleryItems.length) {
					this.sharedSvc.showDependElements(this.dependSelector);
				}
				if (this.layout == GalleryLayout.CAROUSEL || this.layout == GalleryLayout.PREVIEW_CAROUSEL) {
					this.setCarouselItems();
				}
				this.libraryIndex = Math.round(this.galleryItems.length / 2 - 1);
				if (this.autoPlay) this.startPlay();
				let self = this;
				$(document).ready(function() {
					$('#'+self.galleryId).carousel({
						interval: false
					});
					$('#'+self.galleryId).on('slid.bs.carousel', function ($event) {
						// This event handles the completed slide animation.
						// here you can find the direction of the animation and
						// from which to which slide it went.
						// Its useful if you want to track paging etc.
					});
				});
			}
			this.galleryId = `${this.layout}-${Date.now()}`;
		}
	}

	ngOnChanges(changes: SimpleChanges) {
     	if(changes.api && !changes.api.firstChange) {
     		this.init();
		}
	}

	setCarouselItems() {
     	const gallerySize = this.gridInfo && this.gridInfo['itemsPerRow']? this.gridInfo['itemsPerRow'] : this.carouselItems;
		this.carouselArray = _.chunk(this.galleryItems, this.layout == GalleryLayout.PREVIEW_CAROUSEL ? 1 : gallerySize);
	}

	getGridInfo() {
     	// if(!this.responsive) {
     	// 	return {};
		// }
		const screenWidth =  window.innerWidth;
		let responsiveKey = Object.keys(this.responsive).reduce(
			(prev, curr) =>
				(Number(screenWidth) - Number(curr)  <  Number(screenWidth) - Number(prev))
				&& Number(curr) < Number(screenWidth)? curr : prev )
		return this.responsive[responsiveKey];
	}


    getGridInfoByConfigBp(){
        let responsiveKeys = _.keys(this.responsive);
     	const currentKey = this.sharedSvc.getCurrentBp(responsiveKeys);
     	return this.responsive[currentKey];
	}

	setConfig() {
		let config;
		if(Array.isArray(GenericConfig.ngxGalleryConfig)) {
			config = GenericConfig.ngxGalleryConfig.find(item => item.key == this.key);
		}
		const configOptions = GalleryConfigDTO.create(config);
		this.entityConfig = EntityConfig.ngxSigGallery[this.key];
		this.carouselPlayInterval = (this.entityConfig && this.entityConfig.autoplaySpeed) || 5000;
        this.responsive = this.entityConfig?.responsive;
        if(!this.responsive) {
            this.gridInfo =  {};
        } else {
            this.gridInfo =  isNaN(+Object.keys(this.responsive)[0]) ? this.getGridInfoByConfigBp() : this.getGridInfo();
        }

        this.layout = this.gridInfo['layout'] || this.layout || configOptions.layout;
        this.api = this.api || configOptions.api;
        this.hideIndicator = Boolean(this.hideIndicator) || configOptions.hideIndicator;
        this.showOriginalSize = Boolean(this.showOriginalSize) || configOptions.showOriginalSize;
        this.subTitle = this.subTitle || configOptions.subTitle;
        this.hideDescription = Boolean(this.hideDescription) || configOptions.hideDescription;
        this.hideTitle = Boolean(this.hideTitle) || configOptions.hideTitle;
        this.carouselItemsWidth = this.gridInfo['carouselItemsWidth'] || this.entityConfig?.carouselItemsWidth || this.carouselItemsWidth;
		this.openPopupOnFlatClick = this.gridInfo['openPopupOnFlatClick'] || false;
        // set showCarouselButtons
        if(typeof this.gridInfo['showCarouselButtons'] !== 'undefined'){
            this.showCarouselButtons = this.gridInfo['showCarouselButtons'];
        } else if(typeof this.entityConfig?.showCarouselButtons !== 'undefined'){
            this.showCarouselButtons = this.entityConfig?.showCarouselButtons;
        } else {
            this.showCarouselButtons = true;
        }
		if (!this.mediaAssetQuery) {
			if (this.entityConfig?.mediaAssetQuery) {
				this.mediaAssetQuery = this.entityConfig?.mediaAssetQuery;
			} else {
				this.mediaAssetQuery = "showInGallery=true";
			}
		}
		this.filterQuery = this.mediaAssetQuery.split('&').map(s => s.split('='));
    }

	setParams() {
		const device = this.gridInfo['devices'] ? this.gridInfo['devices'] : '';
		this.api += `?entityVar=${this.entityVar}&entityTypeVar=${this.entityTypeVar}&collectionVar=${this.fieldCollectionVar}&device=${device}&orderDirection=${this.orderDirection}`;
		this.api += this.collectionDataId ? `&collectionDataId=${this.collectionDataId}` : '';
	}

	open(content, arrayIndex, index) {
		let self = this;
		this.indexStart = arrayIndex;
     	if (this.carouselArray[arrayIndex][index].link) {
			window.open(this.carouselArray[arrayIndex][index].link, '_blank');
            return;
        }
		 if(this.openPopupOnClick && this.openPopupOnClick == true){
			 // open popup
			 this.modalReference =  this.modalService.open(content, {windowClass : "ngx-gallery-modal"}).result.then((result) => {}, (reason) => {});
			 setTimeout(() => {
				 $('#popup'+self.galleryId).carousel({
					 interval: false
				 });
			 }, 1000);

		 }

	}

	public getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }

    scrollTo(param) {
        let elementSize = document.getElementById(`carousel-selector-${this.index}`).offsetWidth;
	 let element = document.getElementsByClassName('carousel-indicators')[0];
	 if (param == 'prev' && this.index < this.galleryItems.length - 1) {
            this.index += 1;
            element.scrollLeft -= elementSize;
		} else if (this.index > 1) {
            this.index -= 1;
            element.scrollLeft += elementSize;
		}
	}

	galleryHover(index) {
		this.libraryIndex = index;
	}

	startPlay() {
		if (!this.intervalId) {
			this.intervalId = setInterval(() => {
				this.scrollAltCarousel('left', true);
			}, (this.entityConfig && this.entityConfig.autoplaySpeed) || 5000);
		} else {
			this.stopPlay();
		}
	}

	stopPlay() {
		if (this.intervalId) {
			clearInterval(this.intervalId);
			this.intervalId = null;
		}
	}

	scrollAltCarousel(side: string, auto: boolean = false){
     	if(this.entityConfig){
			let slideItems;
			if (auto) {
				slideItems = this.entityConfig.autoSlideItems ? this.entityConfig.autoSlideItems : 1;
			} else {
				slideItems = this.entityConfig.slideItems ? this.entityConfig.slideItems : 1;
			}
			if(this.altCarouselContainer){
				let itemWidth = this.altCarouselContainer.nativeElement.firstChild.clientWidth + (this.gridInfo['gutterHorizontal'] ? (Number(this.gridInfo['gutterHorizontal'].replace(/px$/, ''))*2):0);
				if (side == 'right'){
					if(this.activeIndex > 1)
						this.activeIndex -- ;
					this.altCarouselContainer.nativeElement.scrollLeft += ( itemWidth* slideItems);

				} else if (side == 'left'){
					if(this.activeIndex < this.galleryItems.length - 3)
						this.activeIndex ++ ;
					this.altCarouselContainer.nativeElement.scrollLeft -= (itemWidth * slideItems);
				} else {
					return;
				}
			}
        } else {
    		return;
		}
    }

	routerNavigate(link, event, item = null, content = null){
		event.preventDefault();
		event.stopPropagation();
		var hostname = link.indexOf("//") > -1 ?link.split('/')[2]:link.split('/')[0];
		if (/^https?:\/\//i.test(link) && hostname != location.hostname) {
			window.open(link);
		}else if(/^https?:\/\//i.test(link)){
			window.location.href = link;
		} else {
			if(link) {
				var queryParams = this.setQueryParams(link);
				this.router.navigate([link.split('?')[0]], {
					queryParams
				});
			} else {
				if(this.openPopupOnFlatClick && this.openPopupOnFlatClick == true && item){
					// open popup
					this.showImage = item;
					this.modalReference =  this.modalService.open(content, {windowClass : "ngx-gallery-modal flat"}).result.then((result) => {}, (reason) => {});
				}
			}
		}
	}

	setQueryParams(link) {
		const queryParamsString =  link.split('?')[1]? link.split('?')[1] : '';
		const queryParams = {};
		if(queryParamsString) {
			queryParamsString.split('&').forEach(x => {
				const params = x.split('=');
				queryParams[params[0]] = params[1];
			});
		}
		return  queryParams;
	}

	startPlayCarousel(){
		 if (this.carouselPlayInterval) {
			 this.carouselPlayInterval = 0;
		 } else {
			 this.carouselPlayInterval = (this.entityConfig && this.entityConfig.autoplaySpeed) || 5000;
		 }
	}
}

